export default async function ({ store, redirect }) {
  if (store.getters["user/IS_INF"]) return redirect("/")
  else {
    await Promise.all([
      store.getters["user/IS_BAND"]
        ? store.dispatch("draft/GET_CURRENT")
        : undefined,
      store.dispatch("cart/FETCH"),
      store.dispatch("tag/FETCH"),
    ])
    await store.dispatch("cart/FETCH_MISSING_INFLUENCERS")
  }
}
